import type { ReactNode } from 'react';

import { t } from '../../i18n';
import { cn } from '../../ui/utils';

function Glyph(): ReactNode {
  return (
    <>
      <path
        d="M0 10C0 4.47715 4.47715 0 10 0H18C23.5228 0 28 4.47715 28 10V18C28 23.5228 23.5228 28 18 28H10C4.47715 28 0 23.5228 0 18V10Z"
        className="fill-primary"
      />
      <path
        d="M20.6667 14H19.0133C18.722 13.9994 18.4384 14.0942 18.2061 14.27C17.9737 14.4457 17.8053 14.6928 17.7267 14.9733L16.16 20.5466C16.1499 20.5813 16.1288 20.6117 16.1 20.6333C16.0711 20.655 16.0361 20.6666 16 20.6666C15.9639 20.6666 15.9288 20.655 15.9 20.6333C15.8711 20.6117 15.8501 20.5813 15.84 20.5466L12.16 7.45331C12.1499 7.41869 12.1288 7.38828 12.1 7.36665C12.0711 7.34501 12.0361 7.33331 12 7.33331C11.9639 7.33331 11.9288 7.34501 11.9 7.36665C11.8711 7.38828 11.8501 7.41869 11.84 7.45331L10.2733 13.0266C10.195 13.3061 10.0276 13.5523 9.79657 13.728C9.56556 13.9037 9.28354 13.9991 8.99333 14H7.33333"
        className="stroke-primary-foreground"
        strokeWidth="1.06667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  );
}

/**
 * Figma `140:333` (expanded rail) and `140:349` (collapsed rail) resolve to
 * the same 28×28 node, so one component covers both -- and the auth lockup's
 * own instance, scaled by `className`. `aria-hidden` when a wordmark beside
 * it already names the brand; otherwise the mark carries that name itself,
 * for the one state (the collapsed rail) where the wordmark is gone.
 */
export function Mark(props: { 'aria-hidden'?: boolean; className?: string }): ReactNode {
  const hidden = props['aria-hidden'] ?? false;
  const exposed = hidden
    ? { 'aria-hidden': true as const }
    : { role: 'img' as const, 'aria-label': t('shell.appName') };
  return (
    <svg viewBox="0 0 28 28" fill="none" className={cn('size-7', props.className)} {...exposed}>
      <Glyph />
    </svg>
  );
}
